import React, { forwardRef, memo, useImperativeHandle } from 'react';

import { useDisclosure } from '@chakra-ui/hooks';

import { useSites } from 'hooks/sites/useSites';

import { washHub } from 'store/slices';

import { createCollectionPoint } from 'api/location';
import { useMutation, useQueryClient } from 'react-query';

import { successToast } from 'utils/successToast';

import {
  RefType,
  AddCollectionPointProps,
} from './AddCollectionPointModal.props';

import AddCollectionPointModalView from './AddCollectionPointModal.view';

const Container = forwardRef<RefType, AddCollectionPointProps>((_, ref) => {
  const queryClient = useQueryClient();

  const washHubs = washHub.selectors.useAllWashHubs();
  const washHubId = washHub.selectors.useSelectedWashHubId();

  const { data = [], isLoading } = useSites();
  const { isOpen, onOpen, onClose } = useDisclosure();

  useImperativeHandle(
    ref,
    () => ({
      onOpen,
    }),
    [onOpen],
  );

  const { mutate, isLoading: isCreating } = useMutation(createCollectionPoint, {
    onSuccess: () => {
      successToast('Collection Point Created Successfully');

      queryClient.invalidateQueries(`fetch-collection-points-${washHubId}`);

      queryClient.invalidateQueries(
        `fetch-collection-points-${washHubId}-select`,
        {
          exact: true,
        },
      );

      onClose();
    },
  });

  const completePayloadCollectionsFields = (payload: any) => {
    payload = {
      ...payload,
      washHub: washHubId,
    };
    return payload;
  };

  const _props = {
    isOpen,
    onClose,
    washHub: washHubId,
    isCreating,
    sites: data,
    onCreate: async (payload: any) => {
      const sanitizedPayload = completePayloadCollectionsFields(payload);

      mutate(sanitizedPayload);
    },
    isLoadingSites: isLoading,
  };

  return <AddCollectionPointModalView {..._props} />;
});

const AddCollectionPointModal = memo(Container);

export default AddCollectionPointModal;
